import { useCallback, useEffect, useState } from 'react';
import supabase from '../supabaseClient';
import { checkSubscriptionStatus } from '../utils/subscriptionUtils';

export function usePremiumAccess() {
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);

  const refreshPremium = useCallback(async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      setIsPremium(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    const premium = await checkSubscriptionStatus(user.id);
    setIsPremium(premium);
    setLoading(false);
  }, []);

  useEffect(() => {
    refreshPremium();
  }, [refreshPremium]);

  return { isPremium, loading, refreshPremium };
}
